// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"4":"ScientificProgram","9":"Contact","274":"Home","450":"About","549":"Policy","756":"Events"}[chunkId] || chunkId) + "." + {"0":"bdaf84c2","4":"15ddbe65","9":"2ea53e0d","274":"9d63b545","450":"f3c5de68","549":"ec3084c3","756":"bfcacca6","837":"3a03fd4c"}[chunkId] + ".chunk.js";
};